<template>
     <div>
         <vs-table :data="data">
    <template slot="thead">
      <vs-th class="qb-sticky" v-if="hasPermission(['IU REVIEW ORDER EDIT'])"></vs-th>
      <vs-th>{{ 'folio'| capitalize }}</vs-th>
      <vs-th>{{ 'bulk'|capitalize}}({{'bundle'|capitalize}})</vs-th>
      <vs-th>{{ 'requirement key'| capitalize }}</vs-th>
      <vs-th>{{ 'no part'| capitalize }}</vs-th>
      <vs-th>{{ 'description'| capitalize }}</vs-th>
      <vs-th>{{ 'english description'| capitalize }}</vs-th>
      <vs-th>{{ 'quantity'| capitalize }}</vs-th>
      <vs-th>{{ 'Unidad medida'| capitalize }}</vs-th>
      <vs-th>{{ 'Unidad medida tarifa'| capitalize }}</vs-th>
      <vs-th>{{ 'Factor de conversion'| capitalize }}</vs-th>
      <vs-th>{{ 'warehouse'| capitalize }}</vs-th>
      <vs-th>{{ 'Pais de origen'| capitalize }}</vs-th>
      <vs-th>{{ 'weight'| capitalize }} KG</vs-th>
      <vs-th>{{ 'weight'| capitalize }} LB</vs-th>
      <vs-th>{{ 'V. Unit. Compra'| capitalize }}</vs-th>
      <vs-th>{{ 'V. Unit. Comercial'| capitalize }}</vs-th>
      <vs-th>{{ 'Valor Total USD'| capitalize }}</vs-th>
      <vs-th>{{ 'Marca'| capitalize }}</vs-th>
      <vs-th>{{ 'model'| capitalize }}</vs-th>
      <vs-th>{{ 'serie'| capitalize }}</vs-th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data" :class="[tr.check=='2'?'back-red':'']"> <!-- :style="{backgroundColor:tr.check=='2'?'red':'white',color:'#FFFFFF'}"-->
        <!-- ---------- -->
        <vs-td v-if="hasPermission(['IU REVIEW ORDER EDIT']) && reviewOrderStatusId!='5'">
          <feather-icon
              @click="clickDeleteNoPart(tr.id)"
              icon="TrashIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              color="danger"
            />
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Folio Factura']?(tr.tmps_fields['Folio Factura']!=tr.fields['Folio Factura'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Folio Factura'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Folio Factura']!=tr.fields['Folio Factura'] ? tr.tmps_fields['Folio Factura']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Bultos (Bundles)']?(tr.tmps_fields['Bultos (Bundles)']!=tr.fields['Bultos (Bundles)'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Bultos (Bundles)'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Bultos (Bundles)']!=tr.fields['Bultos (Bundles)'] ? tr.tmps_fields['Bultos (Bundles)']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Clave de pedimento']?(tr.tmps_fields['Clave de pedimento']!=tr.fields['Clave de pedimento'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Clave de pedimento'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Clave de pedimento']!=tr.fields['Clave de pedimento'] ? tr.tmps_fields['Clave de pedimento']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['No. parte']?(tr.tmps_fields['No. parte']!=tr.fields['No. parte'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['No. parte'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['No. parte']!=tr.fields['No. parte'] ? tr.tmps_fields['No. parte']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Descripcion']?(tr.tmps_fields['Descripcion']!=tr.fields['Descripcion'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Descripcion'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Descripcion']!=tr.fields['Descripcion'] ? tr.tmps_fields['Descripcion']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Descripcion en ingles']?(tr.tmps_fields['Descripcion en ingles']!=tr.fields['Descripcion en ingles'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Descripcion en ingles'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Descripcion en ingles']!=tr.fields['Descripcion en ingles'] ? tr.tmps_fields['Descripcion en ingles']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0'?(tr.tmps_fields ? (tr.tmps_fields['Cantidad']?(tr.tmps_fields['Cantidad']!=tr.fields['Cantidad'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Cantidad'] }}
          </div>
          <div :style="{'color':'#26d449'}"  v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Cantidad']!=tr.fields['Cantidad'] ? tr.tmps_fields['Cantidad']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Unidad medida']?(tr.tmps_fields['Unidad medida']!=tr.fields['Unidad medida'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Unidad medida'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Unidad medida']!=tr.fields['Unidad medida'] ? tr.tmps_fields['Unidad medida']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Unidad medida tarifa']?(tr.tmps_fields['Unidad medida tarifa']!=tr.fields['Unidad medida tarifa'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Unidad medida tarifa'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Unidad medida tarifa']!=tr.fields['Unidad medida tarifa'] ? tr.tmps_fields['Unidad medida tarifa']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Factor de conversion']?(tr.tmps_fields['Factor de conversion']!=tr.fields['Factor de conversion'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Factor de conversion'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Factor de conversion']!=tr.fields['Factor de conversion'] ? tr.tmps_fields['Factor de conversion']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['WareHouse']?(tr.tmps_fields['WareHouse']!=tr.fields['WareHouse'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['WareHouse'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['WareHouse']!=tr.fields['WareHouse'] ? tr.tmps_fields['WareHouse']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Pais de origen']?(tr.tmps_fields['Pais de origen']!=tr.fields['Pais de origen'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Pais de origen'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Pais de origen']!=tr.fields['Pais de origen'] ? tr.tmps_fields['Pais de origen']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Peso KG']?(tr.tmps_fields['Peso KG']!=tr.fields['Peso KG'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Peso KG'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Peso KG']!=tr.fields['Peso KG'] ? tr.tmps_fields['Peso KG']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Peso LB']?(tr.tmps_fields['Peso LB']!=tr.fields['Peso LB'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Peso LB'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Peso LB']!=tr.fields['Peso LB'] ? tr.tmps_fields['Peso LB']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['V. Unit. Compra']?(tr.tmps_fields['V. Unit. Compra']!=tr.fields['V. Unit. Compra'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['V. Unit. Compra'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['V. Unit. Compra']!=tr.fields['V. Unit. Compra'] ? tr.tmps_fields['V. Unit. Compra']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['V. Unit. Comercial']?(tr.tmps_fields['V. Unit. Comercial']!=tr.fields['V. Unit. Comercial'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['V. Unit. Comercial'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['V. Unit. Comercial']!=tr.fields['V. Unit. Comercial'] ? tr.tmps_fields['V. Unit. Comercial']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Valor Total USD']?(tr.tmps_fields['Valor Total USD']!=tr.fields['Valor Total USD'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Valor Total USD'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Valor Total USD']!=tr.fields['Valor Total USD'] ? tr.tmps_fields['Valor Total USD']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Marca']?(tr.tmps_fields['Marca']!=tr.fields['Marca'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Marca'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Marca']!=tr.fields['Marca'] ? tr.tmps_fields['Marca']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Modelo']?(tr.tmps_fields['Modelo']!=tr.fields['Modelo'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Modelo'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Modelo']!=tr.fields['Modelo'] ? tr.tmps_fields['Modelo']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        <vs-td>
          <div :style="{'color':tr.check=='0' ? (tr.tmps_fields ? (tr.tmps_fields['Serie']?(tr.tmps_fields['Serie']!=tr.fields['Serie'] ?'#e30a07':'#626262'):'#626262'):'#626262'):'#626262'}"
            :class="[tr.check=='2'?'text-white':'']">
            {{ tr.fields['Serie'] }}
          </div>
          <div :style="{'color':'#26d449'}" v-if="tr.check=='0'">
            {{ tr.tmps_fields ? (tr.tmps_fields['Serie']!=tr.fields['Serie'] ? tr.tmps_fields['Serie']:''):''}}
          </div>
        </vs-td>
        <!-- ---------- -->
        
      </vs-tr>
    </template>
  </vs-table>

  <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
        <p>{{$t('are_you_sure_that_you_want_to_continue')}}</p>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
             ref="loadableButton" 
             id="link-button-loading" 
             class="w-full vs-con-loading__container" 
              color="primary"
              type="filled"
              :disabled="disabled_buttons"
              @click="confirmSubmit"
              > {{$t('i_am_sure')}}</vs-button
            >

          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              :disabled="disabled_buttons"
              @click="confirmActive = false"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      </div>

  
</template>

<script>
import reviewOrder from '@/http/requests/reviewOrder'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
     reviewOrderId: {
      type: String,
      required:true
    },
     reviewOrderStatusId: {
      type: String,
      required:true
    }
  },
  data(){
    return {
      confirmActive:false,
      disabled_buttons:false,
      invoice_id:0
    }
  },
  methods: {
    clickDeleteNoPart(invoice_id){
      this.invoice_id=invoice_id
      this.confirmActive=true
    },
     confirmSubmit(){
      this.disabled_buttons=true
      this.$emit('loadingSubmit',this.disabled_buttons)
      let params={
        invoice_id:this.invoice_id,
        review_order_id:this.reviewOrderId
      }
      reviewOrder.deleteEntries(params).then(res=> {
        this.disabled_buttons=false
        this.$emit('loadingSubmit',this.disabled_buttons)
        this.$emit('itemRemoved')
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Guardado'
        })
        this.confirmActive=false
      }).catch(err=> {
        console.log(err)
        this.disabled_buttons=false
        this.$emit('loadingSubmit',this.disabled_buttons)
        this.confirmActive=false
      })
    },
  },
}
</script>

<style lang="scss">
.back-red{
  background: red;
}

.text-white{
  color: white;
}
</style>